import React from 'react';
import PushChainWallet from './PushChainWallet';
import './LandingPage.css';

const LandingPage = ({ onStartGame, pushChain }) => {
  const handlePlayClick = (e) => {
    e.preventDefault();
    onStartGame();
  };

  const handleVideoError = (e) => {
    console.error('Video failed to load:', e);
    console.error('Video error details:', e.target?.error);
    // Hide video element if it fails to load
    if (e.target) {
      e.target.style.display = 'none';
    }
  };

  const handleVideoLoad = () => {
    console.log('Video loaded successfully');
  };

  return (
    <div className="landing-page">
      {/* Professional Gaming Navbar */}
      <nav className="game-navbar">
        <div className="navbar-container">
          <div className="navbar-brand">
            <img 
              src="/logo.svg" 
              alt="Push Ninja Logo" 
              className="navbar-logo"
            />
            <div className="brand-text">
              <span className="brand-name">Push Ninja</span>
            </div>
          </div>
          
          <div className="navbar-menu">
            <button onClick={handlePlayClick} className="nav-link play-btn">Play Now</button>
            <a href="https://x.com/Kushal2809sm" target="_blank" rel="noopener noreferrer" className="nav-link social-link" aria-label="Twitter">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="https://github.com/Kushcse09" target="_blank" rel="noopener noreferrer" className="nav-link social-link" aria-label="GitHub">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
              </svg>
            </a>
            <PushChainWallet pushChain={pushChain} />
          </div>
        </div>
      </nav>

      {/* Background Video - Full Screen */}
      <video 
        className="hero-bg-video"
        autoPlay 
        muted 
        loop 
        playsInline
        preload="auto"
        disablePictureInPicture
        onError={handleVideoError}
        onLoadedData={handleVideoLoad}
        onCanPlay={() => console.log('Video can play')}
      >
        <source src="/background-video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      
      {/* Video Overlay */}
      <div className="hero-video-overlay"></div>
      
      {/* Main Content Area */}
      <main className="main-content">
        <div className="hero-section">
          <div className="hero-content">
            <div className="hero-title-section">
              <h1 className="hero-game-title">
                <span className="title-slash"></span>
                <span className="title-er"></span>
              </h1>
              <p className="hero-game-subtitle"></p>
            </div>
            <button className="hero-play-button" onClick={handlePlayClick}>
              <span className="play-icon">▶</span>
              Play Now
            </button>
          </div>
        </div>
      </main>

    </div>
  );
};

export default LandingPage;